export default __webpack_public_path__ + "static/media/pa_9.23095e0c.mp3";